import React from 'react';

import { locale } from '@trqk/utils';

/**
 * Renders a toast card with a brief error telling the user they will be sent to the previous page.
 */
export const WorkDetailLoadingError = (): JSX.Element => (
    <div style={{ width: 410 }} className="px-2">
        <div className="font-bold text-highlight-orange tracking-wider mb-2">
            {locale.enUS.TRACK_DETAIL.LOADING_ERROR.TITLE}
        </div>

        <div className="mb-2">
            {locale.enUS.TRACK_DETAIL.LOADING_ERROR.DESCRIPTION}
        </div>
    </div>
);
